export type AvatarState = "idle" | "speaking" | "listening";
export type MouthShape = "closed" | "wide" | "round" | "open";

export function visemeForText(text: string): MouthShape {
  const value = text.trim().toLowerCase();
  if (!value) return "closed";
  if (/[oquw]/.test(value)) return "round";
  if (/[aeiy]/.test(value)) return "wide";
  return "open";
}

export function speechPersonality(value: string): { rate: number; pitch: number } {
  if (value === "direct") return { rate: 1.05, pitch: 0.95 };
  if (value === "analytical") return { rate: 0.92, pitch: 0.98 };
  return { rate: 0.96, pitch: 1.04 };
}
